import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { DURATIONS, EASING } from 'styles/consts'
import { CHECKBOX_SIZE_PX, CheckboxSize } from './consts'

export const LabelWrapper = styled.label<{
  $isDisabled: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: default;
      pointer-events: none;
      opacity: 0.6;
    `}
`

export const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none;
`

export const Box = styled.span<{
  $isChecked: boolean
  $isDisabled: boolean
  $size: CheckboxSize
}>`
  --size: ${({ $size }) => `${CHECKBOX_SIZE_PX[$size]}px`};
  position: relative;
  width: var(--size);
  height: var(--size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid ${COLORS.border};
  border-radius: 4px;
  background: ${COLORS.surface};
  transition:
    background-color ${DURATIONS.fast} ${EASING.out},
    border-color ${DURATIONS.fast} ${EASING.out};

  &:hover {
    border-color: ${COLORS.borderHover};
  }

  ${HiddenCheckbox}:focus-visible + & {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  ${({ $isChecked }) =>
    $isChecked &&
    css`
      border-color: ${COLORS.primary};
      background: ${COLORS.primary};

      &:hover {
        border-color: ${COLORS.primary};
      }
    `}

  path {
    fill: ${COLORS.white};
  }
`
